import React from 'react';
import { isPresent } from 'utils/helperMethods';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import useScreen from 'hooks/useScreen';
import Avatar from 'sharedComponents/Avatar';
import RealEstateAgentPresenter from 'presenters/RealEstateAgentPresenter';

import { Typography } from '@material-ui/core';

import ActionComponent from './components/ActionComponent';

import useStyles from './useStyles';

const RealEstateAgentCard = props => {
  const { realEstateAgent, onAddToWaitlist, isAddingToWaitlist, isInFavorites, isInWaitlist, showActions } = props;
  const classes = useStyles();
  const { isDesktop } = useScreen();
  const { t } = useTranslation();

  const company = RealEstateAgentPresenter.companyName(realEstateAgent);
  const isCompanyPresent = isPresent(company);

  return (
    <div className={classes.container}>
      <div className={classes.paper}>
        <div className={classes.info}>
          <Avatar size="m" imageUrl={RealEstateAgentPresenter.profileImageUrl(realEstateAgent)} />
          <div className={classes.badge}>
            <Typography noWrap variant="subtitle1" color="secondary">
              {t('models.App.userTypes.realEstateAgent')}
            </Typography>
            <Typography noWrap variant="h3" className={classes.name}>
              {RealEstateAgentPresenter.fullName(realEstateAgent)}
            </Typography>
          </div>
          {isDesktop && isCompanyPresent && (
            <div className={classes.badge}>
              <Typography noWrap variant="subtitle1" color="secondary">
                {t('components.LoanOfficerRealEstateAgents.RealEstateAgentsList.RealEstateAgentCard.company')}
              </Typography>
              <Typography noWrap variant="h3" className={classes.name}>
                {company}
              </Typography>
            </div>
          )}
        </div>
        {showActions && (
          <ActionComponent
            isInFavorites={isInFavorites}
            isInWaitlist={isInWaitlist}
            onClick={onAddToWaitlist}
            isLoading={isAddingToWaitlist}
          />
        )}
      </div>
    </div>
  );
};

RealEstateAgentCard.propTypes = {
  realEstateAgent: RealEstateAgentPresenter.shape().isRequired,
  onAddToWaitlist: PropTypes.func,
  isAddingToWaitlist: PropTypes.bool,
  isInFavorites: PropTypes.bool.isRequired,
  isInWaitlist: PropTypes.bool.isRequired,
  showActions: PropTypes.bool,
};

RealEstateAgentCard.defaultProps = {
  onAddToWaitlist: () => {},
  isAddingToWaitlist: false,
  showActions: false,
};

export default RealEstateAgentCard;



// WEBPACK FOOTER //
// ./src/components/LoanOfficerRealEstateAgents/components/RealEstateAgentsList/components/RealEstateAgentCard/RealEstateAgentCard.js